module.exports = __webpack_public_path__ + "img/symbol_1.1329d1a2.png";